import type {
  DatabricksCatalogSettings,
  DatabricksCatalogTreeResponse,
  DatabricksColumnsResponse,
  GenerateColumnDescriptionsResponse,
  UpdateDatabricksCatalogConfigRequest,
} from '@protoss/shared';
import { apiFetch } from '../../../lib/apiClient';

export const dataCatalogApi = {
  getSettings(projectUuid: string): Promise<{ settings: DatabricksCatalogSettings | null }> {
    return apiFetch(`/api/project/${projectUuid}/data-catalog/settings`);
  },

  saveSettings(
    projectUuid: string,
    data: UpdateDatabricksCatalogConfigRequest
  ): Promise<{ ok: boolean }> {
    return apiFetch(`/api/project/${projectUuid}/data-catalog/settings`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  },

  getCatalogTree(projectUuid: string): Promise<DatabricksCatalogTreeResponse> {
    return apiFetch(`/api/project/${projectUuid}/data-catalog/tree`);
  },

  getColumns(
    projectUuid: string,
    catalogName: string,
    schemaName: string,
    tableName: string,
    page: number,
    pageSize: number
  ): Promise<DatabricksColumnsResponse> {
    const params = new URLSearchParams({
      catalog: catalogName,
      schema: schemaName,
      table: tableName,
      page: String(page),
      pageSize: String(pageSize),
    });
    return apiFetch(`/api/project/${projectUuid}/data-catalog/columns?${params}`);
  },

  getMetaCatalogs(projectUuid: string): Promise<{ catalogs: string[] }> {
    return apiFetch(`/api/project/${projectUuid}/data-catalog/meta/catalogs`);
  },

  getMetaSchemas(
    projectUuid: string,
    catalogs: string[]
  ): Promise<{ schemas: { id: string; name: string; catalog: string }[] }> {
    const params = new URLSearchParams({ catalogs: catalogs.join(',') });
    return apiFetch(`/api/project/${projectUuid}/data-catalog/meta/schemas?${params}`);
  },

  getMetaTables(projectUuid: string, schemaIds: string[]): Promise<{ tables: string[] }> {
    const params = new URLSearchParams({ schemas: schemaIds.join(',') });
    return apiFetch(`/api/project/${projectUuid}/data-catalog/meta/tables?${params}`);
  },

  generateColumnDescriptions(
    projectUuid: string,
    catalog: string,
    schema: string,
    table: string
  ): Promise<GenerateColumnDescriptionsResponse> {
    return apiFetch(`/api/project/${projectUuid}/data-catalog/generate-column-descriptions`, {
      method: 'POST',
      body: JSON.stringify({ catalog, schema, table }),
    });
  },
};
